module.exports = __webpack_public_path__ + "img/Stephane_Instadrive.bdad6681.jpg";